<h1>{{'cs.psv.person.profile.edit.header' | hisUi}}</h1>
<div class="clearAndSpace"></div>
<his-dialog-header
  (save)="savePersonProfile()"
  [showBackButton]="true"
  [showResetButton]="false">

  <ng-container dataBox>
    <strong>{{'cs.psv.person.profile.edit' | hisUi:person?.firstname: person?.surname}}</strong>
  </ng-container>

  <ng-container customResultButtons>
    <button (click)="navigationService.navigateToLastBackUrl()"><span>{{'common.back' | hisUi}}</span></button>
  </ng-container>


  @if (personProfileDataExist) {
    <ng-container elementsRight>
      <his-translation-selector [defaultLanguage]="defaultLanguage"></his-translation-selector>
    </ng-container>
  }
</his-dialog-header>

<div class="clearAndSpace"></div>

<!-- Tabs -->
<div>
  <p-tabView id="tabView" class="columnThreeQuarter">
    @if (isMainDataVisible()) {
      <p-tabPanel lazy="true" [header]="'cs.psv.person.profile.basicData.header'|hisUi">
        <his-info-panel [i18nKey]="'cs.psv.person.profile.basicData.header'" [target]="'person.profile'"></his-info-panel>
        @if (personProfile) {
          <psv-personprofile-edit-basic-data
            [defaultLanguage]="defaultLanguage"
            [personProfile]="personProfile"
          ></psv-personprofile-edit-basic-data>
        }
      </p-tabPanel>
    }
    @if (isClassificationsPanelVisible()) {
      <p-tabPanel lazy="true" [header]="'cs.psv.person.profile.classification.header'|hisUi">
        <his-info-panel [i18nKey]="'cs.psv.common.classification'" [target]="'person.profile'"></his-info-panel>
        @if (personProfile && !personProfile.employmentClassificationsDataSource) {
          <psv-personprofile-edit-classifications
            [classifications]="personProfile.personClassifications"
            [header]="'fs.res.common.classifications' | hisUi"
            [researchAreaDdKey]="'cs.psv.person.profile.classification.researchArea'"
            [researchAreaKdsfDdKey]="'cs.psv.person.profile.classification.researchAreaKdsf'"
            [subjectAreaDdKey]="'cs.psv.person.profile.classification.subjectArea'">
          </psv-personprofile-edit-classifications>
        }
        @if (personProfile && personProfile.employmentClassificationsDataSource) {
          <psv-personprofile-edit-employment-classifications
            [employmentClassifications]="personProfile.employmentClassifications">
          </psv-personprofile-edit-employment-classifications>
        }
      </p-tabPanel>
    }
  </p-tabView>
</div>
